import React, { useState, useEffect } from "react";

const ORARI = ["09:00", "10:00", "11:00", "14:00", "15:00", "16:00"];

export default function App() {
  const [prenotazioni, setPrenotazioni] = useState(() => {
    return JSON.parse(localStorage.getItem("prenotazioni")) || [];
  });

  const [form, setForm] = useState({
    nome: "",
    telefono: "",
    moto: "",
    data: "",
    ora: "09:00",
    postazione: "1"
  });

  useEffect(() => {
    localStorage.setItem("prenotazioni", JSON.stringify(prenotazioni));
  }, [prenotazioni]);

  const isWeekend = (date) => {
    const d = new Date(date);
    return d.getDay() === 0 || d.getDay() === 6;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isWeekend(form.data)) {
      alert("Officina chiusa sabato e domenica");
      return;
    }

    const clash = prenotazioni.find(
      p =>
        p.data === form.data &&
        p.ora === form.ora &&
        p.postazione === form.postazione
    );

    if (clash) {
      alert("Postazione già prenotata per questo orario");
      return;
    }

    setPrenotazioni([...prenotazioni, form]);
    alert("Prenotazione confermata! Violetti Factory ti aspetta.");
  };

  return (
    <div style={{ background: "#000", color: "#fff", minHeight: "100vh", padding: 20 }}>
      <header style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <img src="/logo-violetti-factory.png" alt="Violetti Factory" height="50" />
        <h2 style={{ marginLeft: 15 }}>
          Prenotazione tagliandi Violetti Factory
        </h2>
      </header>

      <form onSubmit={handleSubmit}>
        <input placeholder="Nome cliente" onChange={e => setForm({...form, nome: e.target.value})} /><br/>
        <input placeholder="Telefono" onChange={e => setForm({...form, telefono: e.target.value})} /><br/>
        <input placeholder="Moto" onChange={e => setForm({...form, moto: e.target.value})} /><br/>
        <input type="date" onChange={e => setForm({...form, data: e.target.value})} /><br/>

        <select onChange={e => setForm({...form, ora: e.target.value})}>
          {ORARI.map(o => <option key={o}>{o}</option>)}
        </select>

        <select onChange={e => setForm({...form, postazione: e.target.value})}>
          <option value="1">Postazione 1</option>
          <option value="2">Postazione 2</option>
          <option value="3">Postazione 3</option>
        </select>

        <br/><br/>
        <button style={{ background: "#FFD700", padding: 10, border: 0 }}>
          PRENOTA
        </button>
      </form>
    </div>
  );
}
